/**
 * PGSS-5748: which label the supplier's Shipping Label page prints. The 4" x 6" box label (one per page, with the box
 * code as a QR code) is the default; "classic" is the label as it printed before, kept as a fallback. The choice is
 * remembered on this device only.
 */
export const BOX_LABEL = 'box';
export const CLASSIC_LABEL = 'classic';
export const LABEL_STYLE_KEY = 'psg.shippingLabel.style';

/** The remembered choice, or the box label when none (or storage is unavailable). */
export function readLabelStyle(storage) {
  try {
    return storage?.getItem(LABEL_STYLE_KEY) === CLASSIC_LABEL ? CLASSIC_LABEL : BOX_LABEL;
  } catch {
    return BOX_LABEL;
  }
}

/** Remembers the choice; a blocked storage is ignored (the page still prints the chosen label). */
export function writeLabelStyle(storage, style) {
  try {
    storage?.setItem(LABEL_STYLE_KEY, style === CLASSIC_LABEL ? CLASSIC_LABEL : BOX_LABEL);
  } catch {
    // storage blocked: nothing to remember
  }
}

/**
 * The label a page actually shows. Only a page that offers the switch (the supplier Shipping Label page) honours the
 * remembered choice; anywhere else that renders the labels (e.g. the order dialog, where the switch is hidden) always
 * shows the box label.
 */
export function effectiveLabelStyle(labelStyle, canChoose) {
  return canChoose && labelStyle === CLASSIC_LABEL ? CLASSIC_LABEL : BOX_LABEL;
}

/** True when the page prints 4" x 6" box labels (one per page); false for the classic label's A3 sheet. */
export function isBoxLabelPrint(pathType2, labelStyle) {
  return pathType2 === 'shippingLabel' && labelStyle !== CLASSIC_LABEL;
}
